/*jshint esversion: 6 */
// Masonry Layout ========================================================= *
var jQueryBridget = require('jquery-bridget/jquery-bridget');
var Masonry = require('masonry-layout');
$.bridget('masonry', Masonry, $);